import { DocumentBulkUploadResult } from '@monorepo/shared/utils/documentUpload';
import React from 'react';

interface DocumentUploadResultMessageProps {
  rejectedMessages: string[];
  uploadResult: DocumentBulkUploadResult;
}

function MessageList({ messages }: { messages: string[] }) {
  return (
    <>
      {messages.map((message, index) => (
        <React.Fragment key={message}>
          {index > 0 && <br />}
          {message}
        </React.Fragment>
      ))}
    </>
  );
}

export function DocumentUploadResultMessage({
  rejectedMessages,
  uploadResult,
}: DocumentUploadResultMessageProps) {
  const successCount = uploadResult.successes.length;
  const serverFailureMessages = uploadResult.failures.map(
    (f) => `Could not upload "${f.filename}": ${f.error}`,
  );

  return (
    <>
      {successCount > 0 && (
        <>
          {successCount} document{successCount === 1 ? '' : 's'} uploaded.
        </>
      )}
      {rejectedMessages.length > 0 && (
        <>
          {successCount > 0 && <br />}
          These files weren&apos;t uploaded:
          <br />
          <MessageList messages={rejectedMessages} />
        </>
      )}
      {serverFailureMessages.length > 0 && (
        <>
          {(successCount > 0 || rejectedMessages.length > 0) && <br />}
          <MessageList messages={serverFailureMessages} />
        </>
      )}
    </>
  );
}
